import { StoryHistory } from '@/components/StoryHistory.tsx'
import { Button } from '@/components/ui/button.tsx'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog.tsx'
import { isTemporaryId } from '@/utils/key.ts'

type Props = {
  story: Story
}

export const StoryHistoryButton = ({ story }: Props) => {
  return (
    <Dialog>
      <DialogTrigger tabIndex={0} asChild>
        <Button type="button" variant="icon" size="icon" disabled={isTemporaryId(story.id)}>
          <img src="/images/story-history-icon.svg" alt="show story history" />
        </Button>
      </DialogTrigger>

      <DialogContent className="flex flex-col rounded-lg p-4 gap-4 [&>button:last-child]:hidden min-w-[600px] md:min-w-[770px] max-h-[calc(100vh-72px)]">
        <DialogHeader className="w-full pr-12">
          <DialogTitle className="flex items-start w-full overflow-hidden">
            <p className="font-EN-KR-sub-heading-bold text-contents-primary whitespace-nowrap flex-shrink-0 mr-1">
              History of
            </p>
            <p className="font-EN-KR-sub-heading-regular text-contents-tertiary overflow-hidden text-ellipsis whitespace-nowrap">
              {story.title}
            </p>
          </DialogTitle>
          <DialogDescription className="sr-only" />
        </DialogHeader>

        <div className="flex-1">
          <StoryHistory story={story} />
        </div>

        <div className="flex justify-end">
          <DialogClose asChild>
            <Button type="button" variant="outline" className="rounded-sm w-[60px] h-9 font-EN-KR-body1-regular">
              Close
            </Button>
          </DialogClose>
        </div>

        <DialogClose asChild className="absolute top-4 right-4">
          <Button type="button" size="icon" variant="ghost">
            <img src="/images/close-dialog-icon.svg" alt="close" />
          </Button>
        </DialogClose>
      </DialogContent>
    </Dialog>
  )
}
